/**
 * Created by Josef Jurca on 20/01/2018.
 */

import _ from 'lodash';

/**
 * Returns whether or not the response is valid.
 *
 * @param {Object} response - Response.
 * @returns {boolean} True or false.
 */
export function isValidResponse (response) {

    return !_.get(response, ['result', 'error']);
}

/**
 * Returns whether reminder is set for asset.
 *
 * @param {Object} response - Response.
 * @returns {boolean} True or false.
 */
export function hasReminder (response) {

    let totalCount = _.get(response, ['result', 'totalCount']);

    return totalCount > 0;
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/validators/reminder.js